// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dBidOIK4SEw286l1Id9v{border-top:1px solid var(--background-neutral-default);flex-direction:column;gap:4px;padding:8px;display:flex}.gYN_hntd_AZYX3IhOrTB{margin:0}.xwIz5D_4t7UKLqbB0JCy{flex-direction:column;gap:2px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `dBidOIK4SEw286l1Id9v`,
	"whenIcon": `gYN_hntd_AZYX3IhOrTB`,
	"wrapDisabledDateTooltip": `xwIz5D_4t7UKLqbB0JCy`
};
export default ___CSS_LOADER_EXPORT___;
